import React from 'react';
import { Checkbox, CheckboxGroup } from '../../../components/ui/Checkbox';

const EmploymentTypeFilter = ({ selectedTypes, onChange }) => {
  const employmentTypes = [
    { value: 'permanent', label: 'Permanent', count: 234 },
    { value: 'contract', label: 'Contract', count: 156 },
    { value: 'casual', label: 'Casual', count: 89 },
    { value: 'temporary', label: 'Temporary', count: 45 }
  ];

  const handleTypeChange = (typeValue, checked) => {
    if (checked) {
      onChange([...selectedTypes, typeValue]);
    } else {
      onChange(selectedTypes?.filter(t => t !== typeValue));
    }
  };

  const isAllSelected = selectedTypes?.length === employmentTypes?.length;
  const isSomeSelected = selectedTypes?.length > 0 && !isAllSelected;

  const handleSelectAll = (checked) => {
    if (checked) {
      onChange(employmentTypes?.map(t => t?.value));
    } else {
      onChange([]);
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 h-full min-w-0">
      <CheckboxGroup label="Employment Type">
        <Checkbox
          label="Select All"
          checked={isAllSelected}
          indeterminate={isSomeSelected}
          onChange={(e) => handleSelectAll(e?.target?.checked)}
          className="mb-3"
        />
        <div className="space-y-2 pl-3 md:pl-4 border-l-2 border-border">
          {employmentTypes?.map((type) => (
            <div key={type?.value} className="flex items-center justify-between gap-2 min-w-0">
              <Checkbox
                label={type?.label}
                checked={selectedTypes?.includes(type?.value)}
                onChange={(e) => handleTypeChange(type?.value, e?.target?.checked)}
                className="flex-1 min-w-0 truncate"
              />
              <span className="data-text text-xs md:text-sm text-muted-foreground flex-shrink-0 tabular-nums">
                {type?.count}
              </span>
            </div>
          ))}
        </div>
      </CheckboxGroup>
    </div>
  );
};

export default EmploymentTypeFilter;